import React from 'react';
import { Box, Typography } from '@mui/material';
import EventTile from './EventTile';
import { useDraggableScroll } from '../../../hooks/useDraggableScroll';

const DayColumn = ({ day, events, isToday, onEventClick }) => {
    // Enable Drag Scrolling
    const { ref, events: mouseEvents, dragStyle } = useDraggableScroll();

    return (
        <Box sx={{ 
            flex: 1, 
            minWidth: '200px', 
            display: 'flex',
            flexDirection: 'column',
            bgcolor: isToday ? 'white' : 'transparent', 
            borderRadius: 4,
            p: 2,
            boxShadow: isToday ? '0 4px 20px rgba(0,0,0,0.05)' : 'none'
        }}>
            {/* Column Header */}
            <Box sx={{ textAlign: 'center', mb: 2 }}>
                <Typography variant="h6" fontWeight="bold" sx={{ color: isToday ? '#ed8936' : 'rgba(255,255,255,0.8)', textTransform: 'uppercase', fontSize: '0.85rem' }}>
                    {day.toLocaleDateString([], { weekday: 'short' })}
                </Typography>
                <Typography variant="h3" fontWeight="900" sx={{ color: isToday ? '#2d3748' : 'white' }}>
                    {day.getDate()}
                </Typography>
            </Box>

            {/* Draggable Event List Container */}
            <Box 
                ref={ref}
                {...mouseEvents}
                sx={{ 
                    flex: 1, 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: 1.5,
                    pt: 1,
                    ...dragStyle, // Injects cursor, userSelect, overflowY
                    
                    // Hide scrollbar visual completely
                    '&::-webkit-scrollbar': { display: 'none' },
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                }}
            >
                {events.length > 0 ? events.map(event => (
                    <EventTile 
                        key={event.id} 
                        event={event} 
                        onClick={onEventClick} 
                    />
                )) : (
                    <Typography variant="body2" sx={{ textAlign: 'center', opacity: 0.3, mt: 4, fontStyle: 'italic', userSelect: 'none' }}>
                        No events
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default DayColumn;
